import React, { useEffect, useState } from "react";
import { NavLink, Outlet, useLocation, useNavigate } from "react-router-dom";
import {
  LayoutGrid,
  House,
  Search,
  Settings,
  LogOut,
  X,
  Mail,
  KeyRound,
} from "lucide-react";
import "./HRAdminLayout.css";
import HRProfilePage from "../HRAdminpages/HRProfilePage";
import { memoryStorage } from "../../utils/memoryStorage";

const menuItems = [
  {
    title: "Home",
    path: "/HRadmin/HRAdminLayout",
    end: true,
  },
  {
    title: "Job Management",
    path: "/HRadmin/HRAdminLayout/job-management",
  },
  {
    title: "Application Management",
    path: "/HRadmin/HRAdminLayout/application-management",
  },
  {
    title: "Interview Scheduling",
    path: "/HRadmin/HRAdminLayout/interview-scheduling",
  },
  {
    title: "Releasing Offer Letter",
    path: "/HRadmin/HRAdminLayout/releasing-offer-letter",
  },
  {
    title: "Upload Offer Letter",
    path: "/HRadmin/HRAdminLayout/upload-offer-letter",
  },
  {
    title: "Exporting Data",
    path: "/HRadmin/HRAdminLayout/exporting-data",
  },
  {
    title: "Employee Detalis",
    path: "/HRadmin/HRAdminLayout/employee-details",
  },
  {
    title: "Employee Credentials",
    path: "/HRadmin/HRAdminLayout/employee-credentials",
  },
  {
    title: "Bulk Emails",
    path: "/HRadmin/HRAdminLayout/bulk-emails",
  },
];

const HRAdminLayout = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [menuOpen, setMenuOpen] = useState(false);
  const [profileModalOpen, setProfileModalOpen] = useState(false);

  const handleLogout = () => {
    memoryStorage.removeItem("token");
    memoryStorage.removeItem("user");
    navigate("/", { replace: true });
  };

  const handleOpenProfile = () => {
    setProfileModalOpen(true);
    setMenuOpen(false);
  };

  useEffect(() => {
    if (!profileModalOpen) {
      return undefined;
    }

    const handleEscape = (event) => {
      if (event.key === "Escape") {
        setProfileModalOpen(false);
      }
    };

    document.addEventListener("keydown", handleEscape);
    return () => document.removeEventListener("keydown", handleEscape);
  }, [profileModalOpen]);

  return (
    <div className="hr-admin-page">
      <header className="hr-topbar">
        <div className="topbar-left">
          <button
            className="top-icon-btn"
            type="button"
            aria-label="Menu"
            onClick={() => setMenuOpen((prev) => !prev)}
          >
            <LayoutGrid size={25} />
          </button>
          <div className="blackroth-title" aria-label="BlackRoth">
            <span className="blackroth-wordmark">BlackRoth</span>
            <span className="blackroth-mark">TM</span>
          </div>
        </div>
        <div className="topbar-right">
          <div className="header-search">
            <button className="top-icon-btn search-trigger" type="button" aria-label="Search">
              <Search size={18} />
            </button>
            <input
              type="text"
              className="header-search-input"
              placeholder="Search HR panel"
              aria-label="Search HR panel"
            />
          </div>
          <button
            className="brand-pill brand-pill-btn"
            type="button"
            onClick={handleOpenProfile}
            aria-label="Open HR profile"
          >
            <span className="brand-logo" aria-hidden="true">
              <span className="brand-logo-smile" />
            </span>
            <span className="brand-text">HR Panel</span>
          </button>
          <button className="top-icon-btn" type="button" aria-label="Settings">
            <Settings size={20} />
          </button>
          <button className="top-logout-btn" type="button" onClick={handleLogout}>
            <span>Log Out</span>
            <LogOut size={18} className="top-logout-icon" />
          </button>
        </div>
      </header>

      <div className="hr-dashboard-shell">
        {menuOpen && (
          <button
            className="hr-sidebar-backdrop"
            type="button"
            aria-label="Close menu"
            onClick={() => setMenuOpen(false)}
          />
        )}
        <aside className={`hr-sidebar ${menuOpen ? "open" : ""}`}>
        <nav className="sidebar-nav">
          {menuItems.map((item) => {
            const active = item.end
              ? location.pathname === item.path
              : location.pathname === item.path;
            const Icon =
              item.title === "Home"
                ? House
                : item.title === "Bulk Emails"
                  ? Mail
                  : item.title === "Employee Credentials"
                    ? KeyRound
                  : null;
            return (
              <NavLink
                key={item.path}
                to={item.path}
                onClick={() => setMenuOpen(false)}
                className={`sidebar-link ${active ? "active" : ""}`}
                end={item.end}
              >
                {Icon ? <Icon size={16} /> : null}
                <span>{item.title}</span>
              </NavLink>
            );
          })}
        </nav>
        </aside>

        <div className="dashboard-main">
          <main className="dashboard-content">
            <Outlet />
          </main>
        </div>
      </div>

      {profileModalOpen && (
        <div
          className="hr-profile-popup-overlay"
          role="presentation"
          onClick={() => setProfileModalOpen(false)}
        >
          <section
            className="hr-profile-popup"
            role="dialog"
            aria-modal="true"
            aria-label="HR Profile"
            onClick={(event) => event.stopPropagation()}
          >
            <button
              className="hr-profile-popup-close"
              type="button"
              aria-label="Close profile popup"
              onClick={() => setProfileModalOpen(false)}
            >
              <X size={20} />
            </button>
            <div className="hr-profile-popup-content">
              <HRProfilePage />
            </div>
          </section>
        </div>
      )}
    </div>

  );
};

export default HRAdminLayout;




 
